// «¿Este diseño lo hice yo, en este navegador?»
//
// Lo que separa compartir de pisar. Desde ago-2026 el personalizador
// crea la fila del diseño en el primer cambio y deja el token en la
// barra, así que un enlace circula igual que circula cualquier URL: por
// WhatsApp, por email, pegado en una nota. Cuando alguien abre uno hay
// que decidir dos cosas, y las dos se responden aquí:
//
//   · ¿editar esa fila o hacer una copia? (design-session.ts)
//     El diseño de otra persona se copia. El tuyo se sigue editando.
//   · ¿abrir el personalizador solo al cargar la página? (auto-mount.ts)
//     El enlace de otra persona sí — vienes a ver ESE diseño. El tuyo
//     no: es tu propia ficha de producto recargada, y abrirle el editor
//     encima a quien sólo quería mirar el precio es de mal vecino.
//
// Este módulo NO IMPORTA NADA, por el mismo motivo que draft-flag.ts:
// lo lee `auto-mount`, que vive en el entry `embed.js` y se descarga en
// CADA visita a una ficha de producto. Importar aquí el módulo de la
// sesión de diseño arrastraría cart-bridge entero al entry.

const OWNED_KEY = 'bd:designs:owned';
/** Tope de la lista. Un cliente habitual acumula uno por producto y
 *  visita; treinta cubre de sobra y evita que la clave crezca sin fin. */
const OWNED_MAX = 30;

export function readOwnedDesigns(): string[] {
  try {
    const raw = localStorage.getItem(OWNED_KEY);
    if (!raw) return [];
    const j: unknown = JSON.parse(raw);
    return Array.isArray(j) ? j.filter((t): t is string => typeof t === 'string') : [];
  } catch {
    return [];
  }
}

/** ¿Este token lo creamos nosotros? En modo privado / sin
 *  almacenamiento devuelve false, que es el lado seguro por partida
 *  doble: ante la duda copiamos en vez de escribir encima del diseño de
 *  otro, y abrimos el personalizador en vez de esconder el diseño que
 *  el cliente ha venido a ver. */
export function isOwnedDesign(token: string): boolean {
  return readOwnedDesigns().includes(token);
}

export function rememberOwnedDesign(token: string): void {
  try {
    const next = [token, ...readOwnedDesigns().filter((t) => t !== token)].slice(0, OWNED_MAX);
    localStorage.setItem(OWNED_KEY, JSON.stringify(next));
  } catch {
    /* modo privado / cuota — la sesión sigue funcionando en memoria */
  }
}
